import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "tw-flex tw-flex-col tw-gap-20px tw-mb-10px"
};
var _hoisted_2 = {
  class: "tw-relative"
};
var _hoisted_3 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_accessible_select = _resolveComponent("accessible-select");
  var _component_listing_typology_multi_select = _resolveComponent("listing-typology-multi-select");
  var _component_base_floating_label = _resolveComponent("base-floating-label");
  var _component_base_button = _resolveComponent("base-button");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tw-flex tw-flex-col tw-justify-between tw-rounded", _ctx.customClasses])
  }, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_accessible_select, {
    namespace: "filters-re-in-agency",
    "data-cy": "filters-re-in-agency-select",
    label: _ctx.labels.contract,
    "model-value": _ctx.contractType,
    options: _ctx.contractList,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = value => _ctx.contractType = value)
  }, null, 8 /* PROPS */, ["label", "model-value", "options"]), _createCommentVNode(" TYPOLOGY FILTER "), _createElementVNode("div", _hoisted_2, [_createVNode(_component_listing_typology_multi_select, {
    id: "listingTypology",
    "btn-classes": "!tw-font-regular !tw-text tw-rounded-xs tw-border tw-border-w-secondary tw-border-solid",
    "dropdown-classes": "!tw-rounded-xs !tw-border !tw-border-w-secondary !tw-border-solid tw-mt-10px",
    "listing-typologies": _ctx.listingTypologies,
    onTypologyListChanged: _ctx.onLTMSChange
  }, null, 8 /* PROPS */, ["listing-typologies", "onTypologyListChanged"]), _createVNode(_component_base_floating_label, {
    class: "tw-bg-white tw-px-5px",
    "label-text": _ctx.labels.typology,
    "label-state": "floating-label"
  }, null, 8 /* PROPS */, ["label-text"])])]), _createElementVNode("div", null, [_ctx.showDefaultButtonSearch ? (_openBlock(), _createBlock(_component_base_button, {
    key: 0,
    class: "tw-w-full",
    "btn-class": "tw-btn-w-primary",
    "is-loading": _ctx.loadingSearch,
    onClick: _ctx.searchRealEstateInAgency
  }, {
    default: _withCtx(() => [_createElementVNode("span", {
      innerHTML: _ctx.labels.genericSearch
    }, null, 8 /* PROPS */, _hoisted_3)]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["is-loading", "onClick"])) : _createCommentVNode("v-if", true)])], 2 /* CLASS */);
}